// extracted by mini-css-extract-plugin
export var container = "_td-0";
export var table = "_td-2";
export var tableWrapper = "_td-1";